import { render, staticRenderFns } from "./BtnExcluirApoio.vue?vue&type=template&id=627dc1c5"
import script from "./BtnExcluirApoio.vue?vue&type=script&lang=js"
export * from "./BtnExcluirApoio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports